module.exports = __webpack_public_path__ + "img/calendar@2x.d52fc53.jpg";